import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Divider, Box, Button } from '@material-ui/core';

import Header from '../components/Header';
import Sections, { TITLE } from './PersonalScreens';
import NotFound from '../interface/NotFound';
import Menu from '../interface/Menu';
import PersonalManager from '../interface/PersonalManager';
import LoyaltyLevels from '../components/Loyalty/LoyaltyLevels';
import Loader from '../components/Loader';
import NotificationModal from '../components/NotificationModal';
import { useStores } from '../hooks/use-stores';

import './PersonalScreen.css';

const matchTitle = path => {
    return TITLE[path] || '';
};

const Personal = observer(() => {
    const { HeaderStore, CartStore, ProfileDataStore, LoginStore } = useStores();
    const location = useLocation();
    const history = useHistory();
    const [userIsConfirmed, setUserIsConfirmed] = useState(false);
    const [notifyModalOpen, setNotifyModalOpen] = useState(false);

    useEffect(() => {
        const { getProfile } = ProfileDataStore || {};
        const { firstAuthMessageShowed, setFirstAuthMessageShowed } = LoginStore || {};

        getProfile().then(profile => {
            if (profile) {
                if (!profile.confirmed) {
                    setTimeout(() => {
                        history.push('/catalog');
                    }, 100);

                    if (!firstAuthMessageShowed) {
                        setTimeout(() => {
                            setNotifyModalOpen(true);
                        }, 500);
                    }
                } else {
                    history.push('/');
                    setFirstAuthMessageShowed(false);
                }

                setUserIsConfirmed(!!profile.confirmed);
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        CartStore.getCart();
    }, [CartStore]);

    useEffect(() => {
        const title = matchTitle(location.pathname);

        if (title !== '') {
            HeaderStore.setTitle(title);
        }

        return () => {
            HeaderStore.setTitle('');
        };
    }, [HeaderStore, location.pathname]);

    // Handlers
    const triggerLeftMenu = () => {
        const leftMenu = document.querySelector('[class *= "__left-col"]'),
            wrapElemntsPage = document.querySelector('.wrap-page-content');

        leftMenu.classList.toggle('active');
        wrapElemntsPage.style.overflow = 'hidden';
    };

    const handleIsFirstAuthMessageModal = () => {
        setNotifyModalOpen(false);
        LoginStore.setFirstAuthMessageShowed(true);
    };

    // Renders
    if (!ProfileDataStore.profile) {
        return (
            <Box minHeight={400} display="flex" alignItems="center" justifyContent="center">
                <Loader />
            </Box>
        );
    }

    return (
        <>
            <Header />
            <div className="wrap-page-content">
                <button className="trigger-left-menu" onClick={triggerLeftMenu}>
                    Меню
                </button>
                <div className="profile-page pt-30">
                    <div className="profile-page__container">
                        <div className="profile-page__wrap-elemets-page">
                            <div className="profile-page__left-col">
                                <Menu userIsConfirmed={userIsConfirmed} />
                                <div className="profile-card mb-40">
                                    <PersonalManager />
                                </div>
                            </div>
                            <div className="profile-page__right-col">
                                <Switch>
                                    <Route exact path="/" component={userIsConfirmed ? Sections.PersonalArea : null} />

                                    <Route exact path="/catalog" component={Sections.Catalog} />
                                    <Route exact path="/catalog/:categoryId" component={Sections.Category} />
                                    <Route path="/catalog/:categoryId/:productId" component={Sections.Product} />

                                    <Route path="/cart" component={Sections.Cart} />
                                    <Route exact path="/orders/:id" component={userIsConfirmed ? Sections.DetailOrder : null} />

                                    <Route path="/orders" component={userIsConfirmed ? Sections.Orders : null} />

                                    <Route path="/favorites" component={Sections.Favorites} />
                                    <Route path="/discounts" component={userIsConfirmed ? Sections.Discounts : null} />
                                    <Route path="/loyalty" component={userIsConfirmed ? Sections.Loyalty : null} />
                                    <Route path="/profile" component={Sections.Profile} />
                                    <Route path="/tech" component={Sections.Tech} />
                                    <Route path="/instructions/:id" component={Sections.Instruction} />
                                    <Route path="/instructions" component={Sections.Instructions} />

                                    <Route component={NotFound} />
                                </Switch>
                            </div>
                        </div>

                        {location.pathname === '/loyalty' && (
                            <>
                                <Box mt={10} mb={7}>
                                    <Divider />
                                </Box>
                                <LoyaltyLevels />
                            </>
                        )}
                    </div>
                </div>
            </div>

            {notifyModalOpen && (
                <NotificationModal
                    open={true}
                    withoutCloseBtn
                    message="В течение 15 минут менеджер проверит Ваши данные и убедится, что Вы сотрудник компании"
                    bottomBtns={
                        <Box display="flex" justifyContent="center">
                            <Button variant="outlined" color="primary" onClick={handleIsFirstAuthMessageModal}>
                                Хорошо
                            </Button>
                        </Box>
                    }
                />
            )}
        </>
    );
});

export default Personal;
